import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactDOM from "react-dom";
import * as XLSX from "xlsx/xlsx.mjs";
import * as htmlToImage from "html-to-image";
import { startOfDay, endOfDay, format } from "date-fns";
import moment from "moment";
import MicroModal from "micromodal";

import Typography from "../components/Typography";
import InputSearch from "../components/InputSearch/InputSearch";
import Button from "../components/Button/Button";
import ButtonSelect from "../components/ButtonSelect";
import Table from "../components/table/Table";
import FieldContainer from "../components/FieldContainer/FieldContainer";
import DatePicker from "../components/DatePicker";
import SelectTag from "../components/SelectTag/SelectTag";
import Drawer from "../components/Drawer";
import Dots from "../components/Loading/Dots";

import {
  getCampaignsActive,
  GetInteractionsModal,
  GetHistory,
  InteracoesContactNumber,
  getCampaigns,
  getCampaignsActiveV2,
  getCampaignActiveCount,
} from "../actions";
import { changeDisplayByeChat } from "../actions/websocket";
import { PopoverDashboard } from "../actions/Tippy";

import { connection_platform } from "../services/api";

import { ReactComponent as Search } from "../build/images/teams/search-normal.svg";
import { ReactComponent as PDFIcon } from "../build/images/nps-dashboard-icons/pdf.svg";
import { ReactComponent as PrintIcon } from "../build/images/nps-dashboard-icons/print.svg";
import { ReactComponent as ExcelIcon } from "../build/images/nps-dashboard-icons/excel.svg";
import { ReactComponent as Filter } from "../build/images/teams/filter.svg";
import { ReactComponent as MoreIcon } from "../build/images/moreinfo.svg";
import { ReactComponent as WhatsappIcon } from "../build/images/icons-channels/whatsapp2-large.svg";
import { ReactComponent as FacebookIcon } from "../build/images/icons-channels/facebook.svg";
import { ReactComponent as VozIcon } from "../build/images/icons-channels/voz-large.svg";
import { ReactComponent as EmailIcon } from "../build/images/icons-channels/email.svg";
import { ReactComponent as WebchatIcon } from "../build/images/icons-channels/webchat-large.svg";
import { ReactComponent as TelegramIcon } from "../build/images/icons-channels/telegram-large.svg";
import { ReactComponent as GOOGLEGBM } from "../build/images/icons-channels/googlegbm-large.svg";
import { ReactComponent as InstaIcon } from "../build/images/icons-channels/instagram-large.svg";
import { ReactComponent as EmptyState } from "../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as ENCERRARATENDIMENTO } from "../build/images/icons/byeatendant-client-icon.svg";
import { ReactComponent as Interacoes } from "../build/images/popover-queue/people.svg";
import { ReactComponent as Transferir } from "../build/images/icons/transfer-client-icon2.svg";
import { ReactComponent as CleanIcon } from "../build/images/icons/Clean.svg";
import { ReactComponent as TEAMS } from "../build/images/channelsNew/teamsBig.svg";
import LoadingTable from "../build/images/Column.png";

import "../build/css/campaigns.css";
import TransferClientModal from "./TransferClientModal";
import InputSearchBackPagination from "../components/InputSearchBackPagination";
import TableBackPagination from "../components/TableBackPagination";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import ModalWithLoading from "../components/ModalWithLoading";

function defaultSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data.toLowerCase();
  const objectRowB = rowB.original[columnId].data.toLowerCase();

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function numberSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data;
  const objectRowB = rowB.original[columnId].data;

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function customSorting(rowA, rowB, columnId) {
  const customRowA = rowA.original[columnId].config.customOrder;
  const customRowB = rowB.original[columnId].config.customOrder;

  if (customRowA > customRowB) return -1;
  if (customRowB > customRowA) return 1;
  return 0;
}

function dateSorting(rowA, rowB, columnId) {
  const dateRowA = rowA.original[columnId].config.customOrder.getTime();
  const dateRowB = rowB.original[columnId].config.customOrder.getTime();

  if (dateRowA > dateRowB) return -1;
  if (dateRowB > dateRowA) return 1;
  return 0;
}

function dateTimeSorting(rowA, rowB, columnId) {
  const dateRowA = rowA.original[columnId].config.customOrder;
  const dateRowB = rowB.original[columnId].config.customOrder;

  if (dateRowA > dateRowB) return -1;
  if (dateRowB > dateRowA) return 1;
  return 0;
}

export function Campaigns(params) {
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const InfoUsers = useSelector((state) => state.informationusers);

  let campaignsFilters = localStorage.getItem("campaignsFilters")
    ? JSON.parse(localStorage.getItem("campaignsFilters"))
    : "";

  const daysLater = new Date(new Date().setDate(new Date().getDate() - 30));

  const [loading, setLoading] = useState(true);
  const [isLoadingCampaignList, setIsLoadingCampaignList] = useState(false);
  const [dataCampaigns, setDataCampaigns] = useState([]);
  const [dataTotal, setDataTotal] = useState([]);
  const [searchData, setSearchData] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [initialDate, setInitialDate] = useState(
    campaignsFilters ? new Date(campaignsFilters.dataInitial) : daysLater
  );
  const [finalDate, setFinalDate] = useState(
    campaignsFilters ? new Date(campaignsFilters.dataFinal) : new Date()
  );
  const [channelsSelected, setChannelsSelected] = useState(
    campaignsFilters ? campaignsFilters.channels : []
  );
  const [campaignsSelected, setCampaignsSelected] = useState(
    campaignsFilters ? campaignsFilters.campaigns : []
  );
  const [channelsList, setChannelsList] = useState([
    { id: 1, label: "Voz" },
    { id: 2, label: "Webchat" },
    { id: 3, label: "Email" },
    { id: 4, label: "Facebook" },
    { id: 5, label: "Whatsapp" },
    { id: 6, label: "Instagram" },
    { id: 8, label: "Telegram" },
    { id: 11, label: "Google GBM" },
    { id: 15, label: "Teams" },
  ]);
  const [campaignsList, setCampaignsList] = useState([]);
  const [dataExcel, setDataExcel] = useState([]);
  const [columns, setColumns] = useState([
    {
      Header: "DATA DE ENVIO",
      accessor: "dateSend",
      Hint: "DATA DE ENVIO",
      id: "dateSend",
      disableFilters: true,
      sortType: dateSorting,
      display: true,
    },
    {
      Header: "NOME DO CLIENTE",
      accessor: "clientName",
      Hint: "NOME DO CLIENTE",
      id: "clientName",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
      // disableSortBy: true,
    },
    {
      Header: "CONTATO",
      accessor: "phone",
      Hint: "CONTATO",
      id: "phone",
      sortType: defaultSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "CANAL",
      accessor: "channel",
      Hint: "Canal",
      id: "channel",
      disableFilters: true,
      sortType: customSorting,
      display: true,
      // disableSortBy: true,
    },
    {
      Header: "NOME DA CAMPANHA",
      accessor: "campaignName",
      Hint: "NOME DA CAMPANHA",
      id: "campaignName",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "ORIGEM (SAÍDA)",
      accessor: "originNumber",
      Hint: "ORIGEM (SAÍDA)",
      id: "originNumber",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "AÇÃO",
      accessor: "action",
      Hint: "AÇÃO",
      id: "action",
      disableFilters: true,
      sortType: customSorting,
      display: true,
      disableSortBy: true,
    },
  ]);

  const [initialDateV2, setInitialDateV2] = useState(
    campaignsFilters ? new Date(campaignsFilters.dataInitial) : daysLater
  );
  const [finalDateV2, setFinalDateV2] = useState(
    campaignsFilters ? new Date(campaignsFilters.dataFinal) : new Date()
  );
  const [channelsSelectedV2, setChannelsSelectedV2] = useState(
    campaignsFilters ? campaignsFilters.channels : []
  );
  const [campaignsSelectedV2, setCampaignsSelectedV2] = useState(
    campaignsFilters ? campaignsFilters.campaigns : []
  );
  const [totalOfRows, setTotalOfRows] = useState(0);
  const [rowsPage, setRowsPage] = useState(10);
  const [pageOfTable, setPageOfTable] = useState(0);
  const [filter, setFilter] = useState("");
  const [isLoadingExcelGeneration, setIsLoadingExcelGeneration] =
    useState(false);
  const [qtdTotalToFinish, setQtdTotalToFinish] = useState(0);
  const [qtdFinished, setQtdFinished] = useState(0);
  const dispatch = useDispatch();

  let checkSort = localStorage.getItem("sortCampaigns")
    ? JSON.parse(localStorage.getItem("sortCampaigns"))
    : "";

  let sortBy = {
    sortBy: [],
  };

  if (checkSort !== "") {
    sortBy = {
      sortBy: [
        {
          id: checkSort ? checkSort.sort : "dateSend",
          desc: checkSort ? checkSort.sortDesc : false,
        },
      ],
    };
  }

  const renderIcon = (channel) => {
    if (channel === 5) return <WhatsappIcon />;
    if (channel === 4) return <FacebookIcon />;
    if (channel === 3) return <EmailIcon width="32" height="32" />;
    if (channel === 1) return <VozIcon />;
    if (channel === 6) return <InstaIcon />;
    if (channel === 8) return <TelegramIcon />;
    if (channel === 2) return <WebchatIcon />;
    if (channel === 11) return <GOOGLEGBM />;
    if (channel === 15) return <TEAMS />;
  };

  const renderNamechannel = (channel) => {
    if (channel === 5) return "Whatsapp";
    if (channel === 4) return "Facebook";
    if (channel === 3) return "Email";
    if (channel === 1) return "Voz";
    if (channel === 6) return "Instagram";
    if (channel === 8) return "Telegram";
    if (channel === 2) return "Webchat";
    if (channel === 11) return "Google GBM";
    if (channel === 15) return "Teams";
  };

  function displayHistoric(telefone, cdrid) {
    let now = moment().subtract(7, "days");
    const datainit = now.format("YYYY-MM-DD") + "T00:00";
    const datafim = moment().format("YYYY-MM-DD") + "T23:59";
    let idgroup = InfoUsers.idgroup;
    dispatch(InteracoesContactNumber(telefone, datainit, datafim, "", idgroup));
  }

  const showModals = (
    e,
    numberqueue,
    contactname,
    modal,
    cdrid,
    queueid,
    queue
  ) => {
    dispatch(GetInteractionsModal(contactname, numberqueue));

    switch (modal) {
      case "modal__historico-atendimento-queue":
        dispatch(GetHistory([]));
        const agora = moment().subtract(7, "days");
        let histstart = agora.format("YYYY-MM-DDT00:00");
        let histend = moment().format("YYYY-MM-DDT23:59");

        displayHistoric(numberqueue);
        MicroModal.show("modal__historico-atendimento-details");
        break;

      default:
        break;
    }
  };

  const renderOptions = (data) => {
    return (
      <ul className="context-menu__list modals">
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            changeDisplayTransfer(
              event,
              data.idcdr,
              data.scriptid,
              data.idmidia,
              data.iduser
            )
          }
        >
          <Transferir />
          <div className="contact-info__name">Transferir</div>
        </li>
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            showModals(
              event,
              data.number_client,
              data.name_client,
              "modal__historico-atendimento-queue",
              data.idcdr,
              data.queueid,
              data
            )
          }
        >
          <Interacoes />
          <div className="contact-info__name">Ver interações</div>
        </li>
        <li
          className="contact-info contact-info--with-action endAction"
          onClick={(event) => {
            changeDisplayByeChat(
              data.idcdr,
              data.scriptid,
              data.iduser,
              InfoUsers
            );
            setTimeout(() => {
              updateDataCampaignsV2();
            }, 2000);
          }}
        >
          <ENCERRARATENDIMENTO />
          <div className="contact-info__name">Encerrar atendimento</div>
        </li>
      </ul>
    );
  };

  async function handleExcelTableV2() {
    setIsLoadingExcelGeneration(true);
    const excelTable = [];
    const headerAdjust = columns.filter((column) => column.id !== "action");
    const excelHeader = headerAdjust.map((column) => column.Header);
    const headerDisplay = headerAdjust.map((column) => column.display);
    const headerConfigs = [];
    //faz uma requisição que pega todos os dados com os filtros utilizados
    const { updatedAllCampaigns, error } = await getAllDataCampaignsV2();
    //no caso de ter algum erro em alguma das requisições ele dispara o erro
    if (error) {
      toast.error("Ocorreu um erro, tente novamente mais tarde!");
      setIsLoadingExcelGeneration(false);
      return;
    }
    const hasUpdatedAllCampaigns =
      !!updatedAllCampaigns &&
      Array.isArray(updatedAllCampaigns) &&
      updatedAllCampaigns.length > 0;
    //se não tiver nenhum dado para exportar ele sai da função e avisa ao usuário
    if (!hasUpdatedAllCampaigns) {
      toast.error("Não foi encontrada nenhuma campanha para exportar!");
      setIsLoadingExcelGeneration(false);
      return;
    }
    const dataCampaignsToGenerateExcel = updatedAllCampaigns;
    const adjustData = filterExcelTable(dataCampaignsToGenerateExcel);

    adjustData.forEach((datum) => {
      let objectDatum = {
        dateSend: datum.data_envio,

        clientName: datum.name_client,

        phone: datum.number_client,

        channel: renderNamechannel(datum.idmidia),

        campaignName: datum.description,

        originNumber: datum.num_saida,
      };

      excelTable.push(objectDatum);
    });

    let worksheet;

    // if (filtersActive.status.length > 0) {
    //   const statusActive = filtersActive.status.map((status) => status.label);
    //   const excelFiltered = excelTable.filter((column) =>
    //     statusActive.includes(column.status)
    //   );

    //   worksheet = XLSX.utils.json_to_sheet(excelFiltered);
    // } else {
    //   worksheet = XLSX.utils.json_to_sheet(excelTable);
    // }
    worksheet = XLSX.utils.json_to_sheet(excelTable);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Campanhas");
    XLSX.utils.sheet_add_aoa(worksheet, [excelHeader]);

    // const max_width = excelTable.reduce(
    //   (w, r) => Math.max(w, r.client.length),
    //   10
    // );

    const max_width = excelTable.reduce((max, row) => {
      const clientLength = row.campaignName ? row.campaignName.length : "";
      if (clientLength > max) {
        return clientLength;
      }
      return max;
    }, 10);

    while (headerConfigs.length < headerDisplay.length) {
      headerDisplay.forEach((value) => {
        const objectHeader = {
          wch: max_width,
          hidden: !value,
        };

        headerConfigs.push(objectHeader);
      });
    }

    worksheet["!cols"] = headerConfigs;
    XLSX.writeFile(workbook, "ListagemDeCampanhas.xlsx");
    setIsLoadingExcelGeneration(false);
  }

  function handleExcelTable() {
    const excelTable = [];
    const headerAdjust = columns.filter((column) => column.id !== "action");
    const excelHeader = headerAdjust.map((column) => column.Header);
    const headerDisplay = headerAdjust.map((column) => column.display);
    const headerConfigs = [];
    const adjustData = filterExcelTable(dataCampaigns);

    adjustData.forEach((datum) => {
      let objectDatum = {
        dateSend: datum.data_envio,

        clientName: datum.name_client,

        phone: datum.number_client,

        channel: renderNamechannel(datum.idmidia),

        campaignName: datum.description,

        originNumber: datum.num_saida,
      };

      excelTable.push(objectDatum);
    });

    let worksheet;

    // if (filtersActive.status.length > 0) {
    //   const statusActive = filtersActive.status.map((status) => status.label);
    //   const excelFiltered = excelTable.filter((column) =>
    //     statusActive.includes(column.status)
    //   );

    //   worksheet = XLSX.utils.json_to_sheet(excelFiltered);
    // } else {
    //   worksheet = XLSX.utils.json_to_sheet(excelTable);
    // }
    worksheet = XLSX.utils.json_to_sheet(excelTable);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Campanhas");
    XLSX.utils.sheet_add_aoa(worksheet, [excelHeader]);

    // const max_width = excelTable.reduce(
    //   (w, r) => Math.max(w, r.client.length),
    //   10
    // );

    const max_width = excelTable.reduce((max, row) => {
      const clientLength = row.campaignName ? row.campaignName.length : "";
      if (clientLength > max) {
        return clientLength;
      }
      return max;
    }, 10);

    while (headerConfigs.length < headerDisplay.length) {
      headerDisplay.forEach((value) => {
        const objectHeader = {
          wch: max_width,
          hidden: !value,
        };

        headerConfigs.push(objectHeader);
      });
    }

    worksheet["!cols"] = headerConfigs;
    XLSX.writeFile(workbook, "ListagemDeCampanhas.xlsx");
  }

  function filterExcelTable(data) {
    let dataFiltered = data;

    function FormatStringData(data) {
      var dataHora = data.split(" ");
      var dia = dataHora[0].split("/")[0];
      var mes = dataHora[0].split("/")[1];
      var ano = dataHora[0].split("/")[2];

      return ano + "-" + mes + "-" + dia + " " + dataHora[1];
    }

    if (campaignsFilters) {
      dataFiltered = data.filter((datum) => {
        let envioDate = new Date(FormatStringData(datum.data_envio));
        let initialDate = new Date(campaignsFilters.dataInitial);
        let finalDate = new Date(campaignsFilters.dataFinal);

        if (!(envioDate >= initialDate && envioDate <= finalDate)) {
          return false;
        }

        let channelMatch =
          campaignsFilters.channels.length === 0 ||
          campaignsFilters.channels.some(
            (channel) => channel.id === datum.idmidia
          );

        if (!channelMatch) {
          return false;
        }

        let campaignMatch =
          campaignsFilters.campaigns.length === 0 ||
          campaignsFilters.campaigns.some(
            (campaign) => campaign.name === datum.description
          );

        if (!campaignMatch) {
          return false;
        }

        return true;
      });
    }

    return dataFiltered;
  }

  const printContent = async () => {
    const contentElement = document.getElementById("print-content");
    // const pageElement = document.querySelector(".nps-page__content");
    const originalHeight = contentElement.style.height;

    contentElement.style.height = "auto";
    // contentElement.style.overflow = "visible";
    // pageElement.style.overflow = "visible";

    await htmlToImage
      .toPng(contentElement, {
        height: window.innerHeight,
      })
      .then(function (dataUrl) {
        const a = document.createElement("a");
        a.download = "Campanhas_print.png";
        a.href = dataUrl;
        a.click();
        contentElement.style.height = originalHeight;
        // contentElement.style.overflow = "auto";
        // pageElement.style.overflow = "auto";
      })
      .catch(function (error) {
        console.error("oops, something went wrong!", error);
        contentElement.style.height = originalHeight;
        // contentElement.style.overflow = "auto";
        // pageElement.style.overflow = "auto";
      });
  };

  function handleSearch(value) {
    const newData = dataTotal.filter((datum) => {
      if (
        datum.name_client.toLowerCase().includes(value.toLowerCase()) ||
        datum.number_client.toString().includes(value) ||
        datum.description.toLowerCase().includes(value.toLowerCase()) ||
        datum.num_saida.toString().includes(value)
      ) {
        return true;
      }
    });

    setDataCampaigns(newData);
  }

  const changeOptionsChannels = (option) => {
    const arrayFound = channelsSelected.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionChannels(arrayFound.id);
    } else {
      setChannelsSelected([
        ...channelsSelected,
        { id: option.id, name: option.label },
      ]);
    }
  };

  const removeOptionChannels = (idRemoved) => {
    let elements = arrayRemove(channelsSelected, idRemoved);
    setChannelsSelected(elements);
  };

  const changeOptionsCampaigns = (option) => {
    const arrayFound = campaignsSelected.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionCampaigns(arrayFound.id);
    } else {
      setCampaignsSelected([
        ...campaignsSelected,
        { id: option.id, name: option.label },
      ]);
    }
  };

  const removeOptionCampaigns = (idRemoved) => {
    let elements = arrayRemove(campaignsSelected, idRemoved);
    setCampaignsSelected(elements);
  };

  const arrayRemove = (arr, value) => {
    return arr.filter(function (elem) {
      return elem.id != value;
    });
  };

  const cleanFilters = () => {
    const objectFilter = {
      dataInitial: new Date(new Date().setDate(new Date().getDate() - 30)),
      dataFinal: new Date(),
      channels: [],
      campaigns: [],
    };

    //ao limpar os filtros os valores padrões são passados para os estados do filtro
    setInitialDateV2(
      objectFilter ? new Date(objectFilter.dataInitial) : daysLater
    );
    setFinalDateV2(
      objectFilter ? new Date(objectFilter.dataFinal) : new Date()
    );
    setChannelsSelectedV2(objectFilter ? objectFilter.channels : []);
    setCampaignsSelectedV2(objectFilter ? objectFilter.campaigns : []);

    window.localStorage.setItem(
      "campaignsFilters",
      JSON.stringify(objectFilter)
    );
    setOpenFilter(false);
  };

  const applyFilters = () => {
    const objectFilter = {
      dataInitial: initialDate,
      dataFinal: finalDate,
      channels: channelsSelected,
      campaigns: campaignsSelected,
    };

    //ao clicar em aplicar filtro ele passa os valores para os estados do filtro
    setInitialDateV2(
      objectFilter ? new Date(objectFilter.dataInitial) : daysLater
    );
    setFinalDateV2(
      objectFilter ? new Date(objectFilter.dataFinal) : new Date()
    );
    setChannelsSelectedV2(objectFilter ? objectFilter.channels : []);
    setCampaignsSelectedV2(objectFilter ? objectFilter.campaigns : []);

    const dateStart = format(new Date(objectFilter.dataInitial), "yyyy-MM-dd");
    const dateEnd = format(new Date(objectFilter.dataFinal), "yyyy-MM-dd");
    let idCanal = "";
    const hasChannelSelected =
      !!objectFilter.channels &&
      Array.isArray(objectFilter.channels) &&
      objectFilter.channels.length > 0;
    if (hasChannelSelected) {
      idCanal = objectFilter.channels
        .map((channel) => {
          return channel.id;
        })
        .join(",");
    }
    let idCampanha = "";
    const hasCampaignsSelected =
      !!objectFilter.campaigns &&
      Array.isArray(objectFilter.campaigns) &&
      objectFilter.campaigns.length > 0;
    if (hasCampaignsSelected) {
      idCampanha = objectFilter.campaigns
        .map((campaign) => {
          return campaign.id;
        })
        .join(",");
    }

    // ao aplicar o filtro volta para a página 1
    setPageOfTable(0);
    const limit = rowsPage;

    //recarrega os dados da página com o filtro atual
    getDataCampaignsV2(
      dateStart,
      dateEnd,
      idCanal,
      idCampanha,
      filter,
      limit,
      1
    );

    window.localStorage.setItem(
      "campaignsFilters",
      JSON.stringify(objectFilter)
    );
    setOpenFilter(false);
  };

  const changeDisplayTransfer = (e, cdrid, serverid, usermon) => {
    MicroModal.show("modal__transferir__chamada");
    localStorage.setItem("idcdr", cdrid);
    localStorage.setItem("serverid", serverid);
    localStorage.setItem("usermon", usermon);
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // const apenasParaTeste = async () => {
  //   setLoading(true);
  //   //faz uma requisição com todas as linhas para poder encerrar
  //   const { updatedAllCampaigns, error } = await getAllDataCampaignsV2();
  //   //se ocorrer algum erro nas requisições ele sai da função e indica ao usuário que ocorreu um erro
  //   if (error) {
  //     toast.error("Ocorreu um erro, tente novamente!");
  //     setLoading(false);
  //     return;
  //   }

  //   const allDataToCloseAllCampaigns = updatedAllCampaigns;
  //   let data = [
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //     { id: 1 },
  //     { id: 2 },
  //   ];
  //   setQtdTotalToFinish(data.length);
  //   let totalFinished = 0;
  //   setQtdFinished(totalFinished);
  //   MicroModal.close("modal__excluir-campanhas");
  //   MicroModal.show("modal__modal-with-loading");
  //   for (let datum of data) {
  //     await delay(500);
  //     totalFinished++;
  //     setQtdFinished(totalFinished);
  //   }
  //   // let data = filterExcelTable(dataCampaigns);

  //   // await data.forEach((datum) => {
  //   //   changeDisplayByeChat(
  //   //     datum.idcdr,
  //   //     datum.scriptid,
  //   //     datum.iduser,
  //   //     InfoUsers
  //   //   );
  //   // });

  //   //atualiza a página, o parâmetro passado como true indica que devemos voltar a página 1
  //   updateDataCampaignsV2(true);
  //   MicroModal.close("modal__modal-with-loading");
  // };

  const finishAllCampaignsV2 = async () => {
    setLoading(true);
    //faz uma requisição com todas as linhas para poder encerrar
    const { updatedAllCampaigns, error } = await getAllDataCampaignsV2();
    //se ocorrer algum erro nas requisições ele sai da função e indica ao usuário que ocorreu um erro
    if (error) {
      toast.error("Ocorreu um erro, tente novamente!");
      setLoading(false);
      return;
    }
    const hasUpdatedAllCampaigns =
      !!updatedAllCampaigns &&
      Array.isArray(updatedAllCampaigns) &&
      updatedAllCampaigns.length > 0;
    //se não tiver nenhum dado ele indica isso ao usuário e sai da função
    if (!hasUpdatedAllCampaigns) {
      toast.error("Não foi encontrada nenhuma campanha para encerrar!");
      setLoading(false);
      return;
    }
    const allDataToCloseAllCampaigns = updatedAllCampaigns;
    let data = filterExcelTable(allDataToCloseAllCampaigns);
    setQtdTotalToFinish(data.length);
    let totalFinished = 0;
    setQtdFinished(totalFinished);
    MicroModal.close("modal__excluir-campanhas");
    MicroModal.show("modal__modal-with-loading");
    for (let datum of data) {
      changeDisplayByeChat(
        datum.idcdr,
        datum.scriptid,
        datum.iduser,
        InfoUsers
      );

      await delay(500);
      totalFinished++;
      setQtdFinished(totalFinished);
    }
    // let data = filterExcelTable(dataCampaigns);

    // await data.forEach((datum) => {
    //   changeDisplayByeChat(
    //     datum.idcdr,
    //     datum.scriptid,
    //     datum.iduser,
    //     InfoUsers
    //   );
    // });

    //atualiza a página, o parâmetro passado como true indica que devemos voltar a página 1
    updateDataCampaignsV2(true);
    MicroModal.close("modal__modal-with-loading");
  };

  const finishAllCampaigns = async () => {
    setLoading(true);
    let data = filterExcelTable(dataCampaigns);

    for (let datum of data) {
      changeDisplayByeChat(
        datum.idcdr,
        datum.scriptid,
        datum.iduser,
        InfoUsers
      );

      await delay(500);
    }
    // let data = filterExcelTable(dataCampaigns);

    // await data.forEach((datum) => {
    //   changeDisplayByeChat(
    //     datum.idcdr,
    //     datum.scriptid,
    //     datum.iduser,
    //     InfoUsers
    //   );
    // });

    updateDataCampaignsV2(true);
    MicroModal.close("modal__excluir-campanhas");
  };

  // nova função para pegar os dados de forma paginada
  async function getDataCampaignsV2(
    datestart,
    dateend,
    idcanal,
    idcampanha,
    filter,
    limit,
    page
  ) {
    setLoading(true);
    let updatedTotalOfRows = 0;
    let updatedDataCampaigns = [];
    //pega o total de items que tem com os filtros utilizados
    const responseCount = await getCampaignActiveCount(
      datestart,
      dateend,
      idcanal,
      idcampanha,
      filter
    );

    // pega os dados de determinada página com determinados filtros
    const response = await getCampaignsActiveV2(
      datestart,
      dateend,
      idcanal,
      idcampanha,
      filter,
      limit,
      page
    );

    const hasResponse = !!response && response.status === 200;
    const hasResponseCount = !!responseCount && responseCount.status === 200;

    //verifica se todas as chamadas foram realizadas com sucesso
    if (hasResponse && hasResponseCount) {
      const data = response.data;
      const dataCount = responseCount.data;
      const hasData = !!data && Array.isArray(data) && data.length > 0;
      const hasDataCount = !!dataCount;

      if (hasData && hasDataCount) {
        updatedDataCampaigns = data;
        updatedTotalOfRows = dataCount.qtde;
      }
    } else {
      toast.error("Ocorreu um erro, tente novamente mais tarde!");
    }

    setDataCampaigns(updatedDataCampaigns);
    setDataTotal(updatedDataCampaigns);
    setTotalOfRows(updatedTotalOfRows);

    setLoading(false);
  }

  //utilizada para quando desejamos atualizar as informações mantendo ou não a página
  const updateDataCampaignsV2 = useCallback(
    async (isToReturnPageOne = false) => {
      setLoading(true);
      const dateStart = format(initialDateV2, "yyyy-MM-dd");
      const dateEnd = format(finalDateV2, "yyyy-MM-dd");
      let idCanal = "";
      const hasChannelSelected =
        !!channelsSelectedV2 &&
        Array.isArray(channelsSelectedV2) &&
        channelsSelectedV2.length > 0;
      if (hasChannelSelected) {
        idCanal = channelsSelectedV2
          .map((channel) => {
            return channel.id;
          })
          .join(",");
      }
      let idCampanha = "";
      const hasCampaignsSelected =
        !!campaignsSelectedV2 &&
        Array.isArray(campaignsSelectedV2) &&
        campaignsSelectedV2.length > 0;
      if (hasCampaignsSelected) {
        idCampanha = campaignsSelectedV2
          .map((campaign) => {
            return campaign.id;
          })
          .join(",");
      }

      let page = pageOfTable;

      //verifica se a página atual ainda tem dados apos a atualização, se nãoo tiver vai para outra página
      const verifyIfHasDataInThisPage = async (page) => {
        let correctPage = page;
        const isPageOne = page === 0;
        if (isPageOne) {
          return correctPage;
        }

        const response = await getCampaignActiveCount(
          dateStart,
          dateEnd,
          idCanal,
          idCampanha,
          filter
        );

        const hasResponse = !!response && response.status === 200;
        const hasData = hasResponse && !!response.data;
        if (hasResponse && hasData) {
          const data = response.data;
          const pageToComparate = correctPage + 1;
          const maxOfPages = Math.ceil(data.qtde / rowsPage);
          const hasContentInTheCurrentPage = pageToComparate <= maxOfPages;
          if (!hasContentInTheCurrentPage) {
            correctPage = maxOfPages - 1;
          }
        } else {
          correctPage = 0;
        }

        return correctPage;
      };

      //se queremos que volte a página 1, já setemos o valor e não faremos a verificação de conteúdo da página
      if (!isToReturnPageOne) {
        page = await verifyIfHasDataInThisPage(pageOfTable);
      } else {
        page = 0;
      }

      setPageOfTable(page);

      await getDataCampaignsV2(
        dateStart,
        dateEnd,
        idCanal,
        idCampanha,
        filter,
        rowsPage,
        page + 1
      );

      setLoading(false);
    },
    [
      initialDateV2,
      finalDateV2,
      channelsSelectedV2,
      campaignsSelectedV2,
      pageOfTable,
      filter,
      rowsPage,
    ]
  );

  //função utilizada para pegar todos os dados para gerar o excel e encerrar todos os atendimentos
  async function getAllDataCampaignsV2() {
    let updatedAllCampaigns = [];
    let error = false;

    const dateStart = format(initialDateV2, "yyyy-MM-dd");
    const dateEnd = format(finalDateV2, "yyyy-MM-dd");
    let idCanal = "";
    const hasChannelSelected =
      !!channelsSelectedV2 &&
      Array.isArray(channelsSelectedV2) &&
      channelsSelectedV2.length > 0;
    if (hasChannelSelected) {
      idCanal = channelsSelectedV2
        .map((channel) => {
          return channel.id;
        })
        .join(",");
    }
    let idCampanha = "";
    const hasCampaignsSelected =
      !!campaignsSelectedV2 &&
      Array.isArray(campaignsSelectedV2) &&
      campaignsSelectedV2.length > 0;
    if (hasCampaignsSelected) {
      idCampanha = campaignsSelectedV2
        .map((campaign) => {
          return campaign.id;
        })
        .join(",");
    }
    //verifica o número total de informações
    const responseCount = await getCampaignActiveCount(
      dateStart,
      dateEnd,
      idCanal,
      idCampanha,
      filter
    );

    const hasResponseCount = !!responseCount && responseCount.status === 200;
    //verifica se não houve nenhum erro na request do contador
    if (hasResponseCount) {
      const data = responseCount.data;
      const hasData = !!data;

      if (hasData) {
        const limit = data.qtde;
        //pega todos os dados utilizando como limit o valor total de linhas
        const response = await getCampaignsActiveV2(
          dateStart,
          dateEnd,
          idCanal,
          idCampanha,
          filter,
          limit,
          1
        );

        const hasResponse = !!response && response.status === 200;
        if (hasResponse) {
          const dataWithContent = response.data;
          const hasDataWithContent =
            !!dataWithContent &&
            Array.isArray(dataWithContent) &&
            dataWithContent.length > 0;
          if (hasDataWithContent) {
            updatedAllCampaigns = dataWithContent;
          }
        } else {
          error = true;
        }
      } else {
        error = true;
      }
    } else {
      error = true;
    }

    return { updatedAllCampaigns, error };
  }

  async function getAllDataCampaigns() {
    let updatedAllCampaigns = [];
    const response = await getCampaignsActive();

    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      updatedAllCampaigns = response.data;
    }

    return updatedAllCampaigns;
  }

  async function getDataCampaigns() {
    setLoading(true);
    const response = await getCampaignsActive();

    if (response.status === 200) {
      const data = response.data;

      setDataCampaigns(data);
      setDataTotal(data);
    }

    setLoading(false);
  }

  async function getCampaignsList() {
    setIsLoadingCampaignList(true);
    const response = await getCampaigns();

    if (response.status === 200) {
      const data = response.data;

      let formattedData = data.map((datum) => {
        return {
          id: datum.id,
          label: datum.description,
        };
      });
      setCampaignsList(formattedData);
      // return formattedData;
    }

    setIsLoadingCampaignList(false);
  }

  function refactorCampaignsDataV2(data) {
    let formatedData = [];
    let dataFiltered = data;

    function FormatStringData(data) {
      var dataHora = data.split(" ");
      var dia = dataHora[0].split("/")[0];
      var mes = dataHora[0].split("/")[1];
      var ano = dataHora[0].split("/")[2];

      return ano + "-" + mes + "-" + dia + " " + dataHora[1];
    }

    dataFiltered.forEach((datum) => {
      let objectDatum = {
        dateSend: {
          data: datum.data_envio,
          config: {
            customOrder: new Date(FormatStringData(datum.data_envio)),
            className: "cell-gray-text",
          },
        },
        clientName: {
          data: datum.name_client,
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
        phone: {
          data: datum.number_client,
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
        channel: {
          data: renderIcon(datum.idmidia),
          config: {
            className: "cell-gray-text",
            customOrder: datum.idmidia,
          },
        },
        campaignName: {
          data: datum.description,
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
        originNumber: {
          data: datum.num_saida,
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
        action: {
          data: (
            <PopoverDashboard
              trigger="click"
              boundary="window"
              placement="left"
              multiple={true}
              interactive={true}
              content={renderOptions(datum)}
            >
              <MoreIcon style={{ cursor: "pointer" }} />
            </PopoverDashboard>
          ),
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
      };

      formatedData.push(objectDatum);
    });

    return formatedData;
  }

  function refactorCampaignsData(data) {
    let formatedData = [];
    let dataFiltered = data;

    function FormatStringData(data) {
      var dataHora = data.split(" ");
      var dia = dataHora[0].split("/")[0];
      var mes = dataHora[0].split("/")[1];
      var ano = dataHora[0].split("/")[2];

      return ano + "-" + mes + "-" + dia + " " + dataHora[1];
    }

    if (campaignsFilters) {
      dataFiltered = data.filter((datum) => {
        let envioDate = new Date(FormatStringData(datum.data_envio));
        let initialDate = new Date(campaignsFilters.dataInitial);
        let finalDate = new Date(campaignsFilters.dataFinal);

        if (!(envioDate >= initialDate && envioDate <= finalDate)) {
          return false;
        }

        let channelMatch =
          campaignsFilters.channels.length === 0 ||
          campaignsFilters.channels.some(
            (channel) => channel.id === datum.idmidia
          );

        if (!channelMatch) {
          return false;
        }

        let campaignMatch =
          campaignsFilters.campaigns.length === 0 ||
          campaignsFilters.campaigns.some(
            (campaign) => campaign.name === datum.description
          );

        if (!campaignMatch) {
          return false;
        }

        return true;
      });
    }

    dataFiltered.forEach((datum) => {
      let objectDatum = {
        dateSend: {
          data: datum.data_envio,
          config: {
            customOrder: new Date(FormatStringData(datum.data_envio)),
            className: "cell-gray-text",
          },
        },
        clientName: {
          data: datum.name_client,
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
        phone: {
          data: datum.number_client,
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
        channel: {
          data: renderIcon(datum.idmidia),
          config: {
            className: "cell-gray-text",
            customOrder: datum.idmidia,
          },
        },
        campaignName: {
          data: datum.description,
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
        originNumber: {
          data: datum.num_saida,
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
        action: {
          data: (
            <PopoverDashboard
              trigger="click"
              boundary="window"
              placement="left"
              multiple={true}
              interactive={true}
              content={renderOptions(datum)}
            >
              <MoreIcon style={{ cursor: "pointer" }} />
            </PopoverDashboard>
          ),
          config: {
            className: "cell-gray-text",
            customOrder: "",
          },
        },
      };

      formatedData.push(objectDatum);
    });

    return formatedData;
  }

  const campaignsData = useMemo(() => {
    if (dataCampaigns) {
      const dataRefactored = refactorCampaignsDataV2(dataCampaigns);
      // setPageStatus("awaiting");
      return dataRefactored;
    }
  }, [dataCampaigns]);

  // const campaignsData = useMemo(() => {
  //   if (dataCampaigns) {
  //     const dataRefactored = refactorCampaignsData(dataCampaigns);
  //     // setPageStatus("awaiting");
  //     return dataRefactored;
  //   }
  // }, [dataCampaigns, campaignsFilters]);

  function handleChangePage(valueOfPage) {
    const dateStart = format(initialDateV2, "yyyy-MM-dd");
    const dateEnd = format(finalDateV2, "yyyy-MM-dd");
    let idCanal = "";
    const hasChannelSelected =
      !!channelsSelectedV2 &&
      Array.isArray(channelsSelectedV2) &&
      channelsSelectedV2.length > 0;
    if (hasChannelSelected) {
      idCanal = channelsSelectedV2
        .map((channel) => {
          return channel.id;
        })
        .join(",");
    }
    let idCampanha = "";
    const hasCampaignsSelected =
      !!campaignsSelectedV2 &&
      Array.isArray(campaignsSelectedV2) &&
      campaignsSelectedV2.length > 0;
    if (hasCampaignsSelected) {
      idCampanha = campaignsSelectedV2
        .map((campaign) => {
          return campaign.id;
        })
        .join(",");
    }

    // ao clicar em uma nova página gera a informação da página clicada
    getDataCampaignsV2(
      dateStart,
      dateEnd,
      idCanal,
      idCampanha,
      filter,
      rowsPage,
      valueOfPage + 1
    );
  }

  function handleChangeRowsPerPage(valueOfRowsPerPage) {
    const dateStart = format(initialDateV2, "yyyy-MM-dd");
    const dateEnd = format(finalDateV2, "yyyy-MM-dd");
    let idCanal = "";
    const hasChannelSelected =
      !!channelsSelectedV2 &&
      Array.isArray(channelsSelectedV2) &&
      channelsSelectedV2.length > 0;
    if (hasChannelSelected) {
      idCanal = channelsSelectedV2
        .map((channel) => {
          return channel.id;
        })
        .join(",");
    }
    let idCampanha = "";
    const hasCampaignsSelected =
      !!campaignsSelectedV2 &&
      Array.isArray(campaignsSelectedV2) &&
      campaignsSelectedV2.length > 0;
    if (hasCampaignsSelected) {
      idCampanha = campaignsSelectedV2
        .map((campaign) => {
          return campaign.id;
        })
        .join(",");
    }

    //ao modificar a quantidade de linhas por página ele volta a página 1 e gera novamente os dados com a quantidade de linhas definidas
    getDataCampaignsV2(
      dateStart,
      dateEnd,
      idCanal,
      idCampanha,
      filter,
      valueOfRowsPerPage,
      1
    );
  }

  function handleTableDataLookupV2(event) {
    setPageOfTable(0);
    setFilter(event);

    const dateStart = format(initialDateV2, "yyyy-MM-dd");
    const dateEnd = format(finalDateV2, "yyyy-MM-dd");
    let idCanal = "";
    const hasChannelSelected =
      !!channelsSelectedV2 &&
      Array.isArray(channelsSelectedV2) &&
      channelsSelectedV2.length > 0;
    if (hasChannelSelected) {
      idCanal = channelsSelectedV2
        .map((channel) => {
          return channel.id;
        })
        .join(",");
    }
    let idCampanha = "";
    const hasCampaignsSelected =
      !!campaignsSelectedV2 &&
      Array.isArray(campaignsSelectedV2) &&
      campaignsSelectedV2.length > 0;
    if (hasCampaignsSelected) {
      idCampanha = campaignsSelectedV2
        .map((campaign) => {
          return campaign.id;
        })
        .join(",");
    }

    //ao digitar algo na busca e apertar enter ou clicar na lupa ele busca as informações com essas informações e volta para a página 1
    getDataCampaignsV2(
      dateStart,
      dateEnd,
      idCanal,
      idCampanha,
      event,
      rowsPage,
      1
    );

    //   const dateStart = format(
    //     new Date(agentDashboardFilter.initialDateAgenteScreen),
    //     "yyyy-MM-dd"
    //   );
    //   const dateEnd = format(
    //     new Date(agentDashboardFilter.finalDateAgentScreen),
    //     "yyyy-MM-dd"
    //   );
    //   const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
    //     .map((option) => option.id)
    //     .join(",");
    //   const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
    //     .map((option) => option.id)
    //     .join(",");
    //   setPageOfTable(0);
    //   setFilter(event);

    //   let perfilNPS = "";
    //   const hasFiltersNPS =
    //     !!filtersNPS && Array.isArray(filtersNPS) && filtersNPS.length > 0;
    //   if (hasFiltersNPS) {
    //     const activesFiltersNPS = filtersNPS.filter((datum) => {
    //       return datum.active;
    //     });
    //     const hasActivesFiltersNPS =
    //       !!activesFiltersNPS &&
    //       Array.isArray(activesFiltersNPS) &&
    //       activesFiltersNPS.length > 0;
    //     if (hasActivesFiltersNPS) {
    //       perfilNPS = activesFiltersNPS[0].id;
    //     }
    //   }

    //   updateListDealV2(
    //     dateStart,
    //     dateEnd,
    //     idsChannel,
    //     idsAvaliation,
    //     1,
    //     rowsPage,
    //     event,
    //     perfilNPS
    //   );

    //   setPageOfTableCSAT(0);

    //   let perfilCSAT = "";
    //   const hasFiltersCSAT =
    //     !!filtersCSAT && Array.isArray(filtersCSAT) && filtersCSAT.length > 0;
    //   if (hasFiltersCSAT) {
    //     const activesFiltersCSAT = filtersCSAT.filter((datum) => {
    //       return datum.active;
    //     });
    //     const hasActivesFiltersCSAT =
    //       !!activesFiltersCSAT &&
    //       Array.isArray(activesFiltersCSAT) &&
    //       activesFiltersCSAT.length > 0;
    //     if (hasActivesFiltersCSAT) {
    //       perfilCSAT = activesFiltersCSAT[0].id;
    //     }
    //   }

    //   updateListDealV2CSAT(
    //     dateStart,
    //     dateEnd,
    //     idsChannel,
    //     idsAvaliation,
    //     1,
    //     rowsPage,
    //     event,
    //     perfilCSAT
    //   );
  }

  function handleChangeInputSearch(value) {
    //verifica se o campo de busca ficou vazio e reefaz a busca
    const isValueEmpty = value === "";
    if (isValueEmpty) {
      setFilter("");
      const dateStart = format(initialDateV2, "yyyy-MM-dd");
      const dateEnd = format(finalDateV2, "yyyy-MM-dd");
      let idCanal = "";
      const hasChannelSelected =
        !!channelsSelectedV2 &&
        Array.isArray(channelsSelectedV2) &&
        channelsSelectedV2.length > 0;
      if (hasChannelSelected) {
        idCanal = channelsSelectedV2
          .map((channel) => {
            return channel.id;
          })
          .join(",");
      }
      let idCampanha = "";
      const hasCampaignsSelected =
        !!campaignsSelectedV2 &&
        Array.isArray(campaignsSelectedV2) &&
        campaignsSelectedV2.length > 0;
      if (hasCampaignsSelected) {
        idCampanha = campaignsSelectedV2
          .map((campaign) => {
            return campaign.id;
          })
          .join(",");
      }

      setPageOfTable(0);

      getDataCampaignsV2(
        dateStart,
        dateEnd,
        idCanal,
        idCampanha,
        "",
        rowsPage,
        1
      );
    }
    // if (isValueEmpty) {
    //   setFilter("");
    //   const dateStart = format(
    //     new Date(agentDashboardFilter.initialDateAgenteScreen),
    //     "yyyy-MM-dd"
    //   );
    //   const dateEnd = format(
    //     new Date(agentDashboardFilter.finalDateAgentScreen),
    //     "yyyy-MM-dd"
    //   );
    //   const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
    //     .map((option) => option.id)
    //     .join(",");
    //   const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
    //     .map((option) => option.id)
    //     .join(",");
    //   setPageOfTable(0);

    //   let perfilNPS = "";
    //   const hasFiltersNPS =
    //     !!filtersNPS && Array.isArray(filtersNPS) && filtersNPS.length > 0;
    //   if (hasFiltersNPS) {
    //     const activesFiltersNPS = filtersNPS.filter((datum) => {
    //       return datum.active;
    //     });
    //     const hasActivesFiltersNPS =
    //       !!activesFiltersNPS &&
    //       Array.isArray(activesFiltersNPS) &&
    //       activesFiltersNPS.length > 0;
    //     if (hasActivesFiltersNPS) {
    //       perfilNPS = activesFiltersNPS[0].id;
    //     }
    //   }

    //   updateListDealV2(
    //     dateStart,
    //     dateEnd,
    //     idsChannel,
    //     idsAvaliation,
    //     1,
    //     rowsPage,
    //     "",
    //     perfilNPS
    //   );

    //   setPageOfTableCSAT(0);

    //   let perfilCSAT = "";
    //   const hasFiltersCSAT =
    //     !!filtersCSAT && Array.isArray(filtersCSAT) && filtersCSAT.length > 0;
    //   if (hasFiltersCSAT) {
    //     const activesFiltersCSAT = filtersCSAT.filter((datum) => {
    //       return datum.active;
    //     });
    //     const hasActivesFiltersCSAT =
    //       !!activesFiltersCSAT &&
    //       Array.isArray(activesFiltersCSAT) &&
    //       activesFiltersCSAT.length > 0;
    //     if (hasActivesFiltersCSAT) {
    //       perfilCSAT = activesFiltersCSAT[0].id;
    //     }
    //   }

    //   updateListDealV2CSAT(
    //     dateStart,
    //     dateEnd,
    //     idsChannel,
    //     idsAvaliation,
    //     1,
    //     rowsPage,
    //     "",
    //     perfilCSAT
    //   );
    // }
  }
  // useEffect(() => {
  //   MicroModal.show("modal__excluir-campanhas");
  // }, []);

  useEffect(() => {
    const dateStart = format(initialDateV2, "yyyy-MM-dd");
    const dateEnd = format(finalDateV2, "yyyy-MM-dd");
    let idCanal = "";
    const hasChannelSelected =
      !!channelsSelectedV2 &&
      Array.isArray(channelsSelectedV2) &&
      channelsSelectedV2.length > 0;
    if (hasChannelSelected) {
      idCanal = channelsSelectedV2
        .map((channel) => {
          return channel.id;
        })
        .join(",");
    }
    let idCampanha = "";
    const hasCampaignsSelected =
      !!campaignsSelectedV2 &&
      Array.isArray(campaignsSelectedV2) &&
      campaignsSelectedV2.length > 0;
    if (hasCampaignsSelected) {
      idCampanha = campaignsSelectedV2
        .map((campaign) => {
          return campaign.id;
        })
        .join(",");
    }

    getDataCampaignsV2(
      dateStart,
      dateEnd,
      idCanal,
      idCampanha,
      "",
      rowsPage,
      1
    );
    getCampaignsList();
  }, []);

  // de tempos em tempos a página é atualizada
  useEffect(() => {
    const checkCampaigns = setInterval(() => {
      updateDataCampaignsV2();
    }, connection_platform.timeCampaigns);

    return () => {
      clearInterval(checkCampaigns);
    };
  }, [updateDataCampaignsV2]);

  // useEffect(() => {
  //   getDataCampaigns();
  //   getCampaignsList();

  //   const checkCampaigns = setInterval(() => {
  //     getDataCampaigns();
  //   }, connection_platform.timeCampaigns);

  //   return () => {
  //     clearInterval(checkCampaigns);
  //   };
  // }, []);

  // useEffect(() => {
  //   if (!searchData) {
  //     setDataCampaigns(dataTotal);
  //   }
  // }, [searchData]);

  useEffect(() => {
    setInitialDate(
      campaignsFilters ? new Date(campaignsFilters.dataInitial) : daysLater
    );
    setFinalDate(
      campaignsFilters ? new Date(campaignsFilters.dataFinal) : new Date()
    );
    setChannelsSelected(campaignsFilters ? campaignsFilters.channels : []);
    setCampaignsSelected(campaignsFilters ? campaignsFilters.campaigns : []);
  }, [openFilter]);

  let compareInitial =
    initialDate.toDateString() !== daysLater.toDateString() ? 1 : 0;
  let compareFinal =
    finalDate.toDateString() !== new Date().toDateString() ? 1 : 0;
  let filtersMax =
    channelsSelected.length +
    campaignsSelected.length +
    +compareInitial +
    compareFinal;

  return (
    <div id="print-content" className="campaigns">
      <header>
        <Typography.H2 color={"gray-180"}>Campanhas</Typography.H2>
        {/* <div className="full-search">
          <input
            type="text"
            name="client-search"
            id="client-search"
            placeholder="Pesquisar atendente"
            onChange={(event) => this.changeAgentGroup(event, "")}
          />
          <button type="submit" className="full-search__btn">
            <Search />
          </button>
        </div> */}
        {/* <InputSearch
          search={searchData}
          setSearch={setSearchData}
          // handleClick={(e) => handleSearch(searchData)}
          onSearch={(e) => handleSearch(searchData)}
          onKeyDown={true}
        /> */}
        <InputSearchBackPagination
          search={searchData}
          setSearch={setSearchData}
          onSearch={() => handleTableDataLookupV2(searchData)}
          onChange={(value) => {
            handleChangeInputSearch(value);
          }}
          onKeyDown={true}
        />

        <div className="icons-action">
          {isLoadingExcelGeneration ? (
            <CircularProgress size="24px" />
          ) : (
            <ExcelIcon onClick={handleExcelTableV2} />
          )}
          {/* <PDFIcon /> */}
          <PrintIcon onClick={printContent} />
        </div>
        <ButtonSelect
          type="tertiary"
          children={
            !loading ? (
              <Typography.H4
                color={campaignsData.length === 0 ? "gray-180" : "red-2"}
              >
                Encerrar todos os atendimentos
              </Typography.H4>
            ) : (
              <Dots />
            )
          }
          onClick={() => {
            if (!loading) {
              MicroModal.show("modal__excluir-campanhas");
            } else {
              return null;
            }
          }}
          disabled={campaignsData.length === 0}
        />
        <ButtonSelect
          type="fourthiary"
          icon={<Filter width="24" height="24" />}
          children={
            <Typography.H4 color={"blue-selected-4"}>
              Filtros
              {filtersMax > 0 ? (
                <span className="total-filters">{filtersMax}</span>
              ) : (
                ""
              )}
            </Typography.H4>
          }
          onClick={() => setOpenFilter(true)}
        />
      </header>

      <main>
        {/* LoginCompleteReducer.isLoginComplete && !loading  */}
        {LoginCompleteReducer.isLoginComplete && !loading ? (
          campaignsData.length !== 0 ? (
            // <Table
            //   className="table-operatorsManagers"
            //   data={campaignsData}
            //   columns={columns}
            //   fixedHeader
            //   // fixedFirstColumn
            //   // filtersActive={filtersActive}
            //   // emptyState={emptyState}
            //   // setEmptyState={setEmptyState}
            //   initialState={sortBy}
            //   screen="campaigns"
            //   rowShadowLine
            // />
            <TableBackPagination
              fixedHeader
              columns={columns}
              data={campaignsData}
              initialState={sortBy}
              totalOfRows={totalOfRows}
              setRowsPage={setRowsPage}
              rowsPage={rowsPage}
              setPageOfTable={setPageOfTable}
              pageOfTable={pageOfTable}
              isloading={loading}
              onChangePage={(valueOfPage) => {
                handleChangePage(valueOfPage);
              }}
              onChangeRowsPerPage={(valueOfRowsPerPage) => {
                handleChangeRowsPerPage(valueOfRowsPerPage);
              }}
              isDisabled={loading}
            />
          ) : (
            <div className="manager-component__card-table__area-empty">
              <EmptyState />
            </div>
          )
        ) : (
          <img className="img-table" src={LoadingTable} alt="loading" />
        )}
      </main>

      <Drawer.Main
        title="Filtros"
        isOpen={openFilter}
        onClose={() => setOpenFilter(false)}
        footerContent={
          <div className="filter-campaigns-footer">
            <ButtonSelect
              type="tertiary"
              icon={<CleanIcon width="24" height="24" />}
              children={"Limpar Filtros"}
              onClick={() => cleanFilters()}
            />
            <ButtonSelect
              type="primary"
              children={"Aplicar Filtro"}
              sizeFont={"16px"}
              onClick={() => applyFilters()}
            />
          </div>
        }
      >
        <div className="filter-campaigns">
          <FieldContainer title="Data inicial" htmlFor="">
            <DatePicker.DateRange
              selected={initialDate}
              setDate={(event) => {
                const newDate = startOfDay(event);
                setInitialDate(newDate);
              }}
              selectRangeType="start"
              endDate={finalDate}
              maxDate={finalDate}
              dateFormat={"dd/MM/yyyy"}
            ></DatePicker.DateRange>
          </FieldContainer>
          <FieldContainer title="Data final" htmlFor="">
            <DatePicker.DateRange
              selected={finalDate}
              setDate={(event) => {
                const newDate = endOfDay(event);
                setFinalDate(newDate);
              }}
              selectRangeType="end"
              startDate={initialDate}
              minDate={initialDate}
              dateFormat={"dd/MM/yyyy"}
            />
          </FieldContainer>
          <FieldContainer title="Canal" htmlFor="">
            <SelectTag
              valueTag={channelsSelected}
              options={channelsList}
              onSelect={(option) => {
                changeOptionsChannels(option);
              }}
            />
          </FieldContainer>
          <FieldContainer title="Campanha" htmlFor="">
            <SelectTag
              valueTag={campaignsSelected}
              options={campaignsList}
              onSelect={(option) => {
                changeOptionsCampaigns(option);
              }}
            />
          </FieldContainer>
        </div>
      </Drawer.Main>

      <TransferClientModal
        dashboardMonitor={true}
        onTransferCampaign={updateDataCampaignsV2}
      />

      <div
        className="modal micromodal-slide"
        id="modal__excluir-campanhas"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__excluir-campanhas__title"
          >
            <header className="modal__header">
              <Typography.H2 color={"blue-selected-4"} weight={700}>
                Encerrar todos os atendimentos filtrados?
              </Typography.H2>
              <button
                className="modal__close"
                aria-label="Close modal"
                onClick={(event) =>
                  MicroModal.close("modal__excluir-campanhas")
                }
              ></button>
            </header>
            <main
              className="modal__content"
              id="modal__excluir-campanhas__content"
            >
              <div className="modal__excluir-campanhas__warning">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M21.8955 18.4074L12.8952 1.26861C12.5562 0.624004 11.4451 0.624004 11.1061 1.26861L2.10583 18.4074C1.95183 18.7026 1.96683 19.052 2.14984 19.3348C2.33184 19.6147 2.65285 19.7852 2.99986 19.7852H21.0005C21.3475 19.7852 21.6685 19.6138 21.8515 19.3338C22.0335 19.052 22.0495 18.7035 21.8955 18.4074ZM11.0001 8.3593H13.0002V14.0722H11.0001V8.3593ZM12.0002 17.1667C11.3101 17.1667 10.7501 16.6345 10.7501 15.9765C10.7501 15.3196 11.3101 14.7863 12.0002 14.7863C12.6902 14.7863 13.2502 15.3196 13.2502 15.9765C13.2502 16.6345 12.6902 17.1667 12.0002 17.1667Z"
                    fill="#F2BD00"
                  />
                </svg>
                <div className="modal__excluir-campanhas__warning_text">
                  <Typography.H4 color={"gray-600"} weight={500}>
                    Atenção!
                  </Typography.H4>
                  <Typography.H4 color={"gray-180"}>
                    Após a confirmação, a ação não poderá ser desfeita.
                  </Typography.H4>
                </div>
              </div>
              <Typography.H4
                className={"excluir-campanhas__warning-text"}
                color={"gray-180"}
                weight={500}
              >
                Você está prestes a encerrar todos os atendimentos que atendem
                ao filtro aplicado. Isso significa que apenas os atendimentos
                que correspondem aos critérios do filtro serão finalizados
                automaticamente.
              </Typography.H4>
            </main>
            <footer className="modal__footer">
              <ButtonSelect
                type="fourthiary"
                children={
                  <Typography.H4 color={"blue-selected-4"}>
                    Cancelar
                  </Typography.H4>
                }
                onClick={() => MicroModal.close("modal__excluir-campanhas")}
              />
              <ButtonSelect
                type="secondary"
                children={
                  <Typography.H4 color={"white"}>
                    Sim, encerrar todos os atendimentos
                  </Typography.H4>
                }
                onClick={() => finishAllCampaignsV2()}
              />
            </footer>
          </div>
        </div>
      </div>
      <ModalWithLoading
        qtdTotal={qtdTotalToFinish}
        qtdCompleteds={qtdFinished}
      />
    </div>
  );
}
